import { Badge, Card, Descriptions, Form, Select } from 'antd';
import { observer } from 'mobx-react-lite';

import { TTrip } from '../../core/trips';
import { requiredRules, useErrorFieldsStatusContext } from './form-utils';

type TripStatusCardProps = {
  trip: TTrip;
};

export const TripStatusCard = observer(({ trip }: TripStatusCardProps) => {
  const errorFieldsStatus = useErrorFieldsStatusContext();

  return (
    <Card size="small" title="Статус">
      <Descriptions bordered size="small" column={1}>
        <Descriptions.Item
          label="ID рейса"
          labelStyle={{ width: '1%', whiteSpace: 'nowrap' }}
        >
          {trip.id}
        </Descriptions.Item>
        <Descriptions.Item
          label="Доступность"
          labelStyle={{ width: '1%', whiteSpace: 'nowrap' }}
        >
          <Form.Item name="blocked" rules={requiredRules} noStyle={true}>
            <Select
              style={{ width: '50%' }}
              status={errorFieldsStatus.getFieldStatus('blocked')}
            >
              <Select.Option value={false}>
                <Badge status="success" text="Доступен" />
              </Select.Option>
              <Select.Option value={true}>
                <Badge status="error" text="Заблокирован" />
              </Select.Option>
            </Select>
          </Form.Item>
        </Descriptions.Item>
      </Descriptions>
    </Card>
  );
});
